import {
  IconEnvelope,
  IconMapMarker,
  IconPhone,
  IconTrophy,
  IconUserCircle,
} from '@maia/icons';
import { InsuranceDto } from '@maia/shared';
import { SpecList, TextButtonLink, cardStyles } from '@maia/ui';
import { formatAddress, formatDate } from '@maia/utils';
import { twMerge } from 'tailwind-merge';

type Props = {
  customer: InsuranceDto['customer'];
};

export function CustomerInformation(props: Props) {
  const { customer } = props;

  return (
    <div className="flex flex-col gap-y-24">
      <div className="flex flex-row items-center gap-x-12">
        <IconUserCircle className="min-w-24 w-24 h-24 fill-primaryMain" />

        <div className="flex flex-col">
          <TextButtonLink
            size="tiny"
            to="/customers/$guid"
            params={{ guid: customer.guid }}
          >
            {customer.consumer.fullName}
          </TextButtonLink>
        </div>
      </div>

      <div className={twMerge(cardStyles({ variant: 'flat' }), 'p-12')}>
        <SpecList
          items={[
            ...(customer.consumer.email
              ? [{ icon: IconEnvelope, title: customer.consumer.email }]
              : []),

            ...(customer.consumer.phone
              ? [{ icon: IconPhone, title: customer.consumer.phone }]
              : []),

            ...(customer.address
              ? [
                  {
                    icon: IconMapMarker,
                    title: formatAddress(customer.address),
                  },
                ]
              : []),

            ...(customer.activeSince
              ? [{ icon: IconTrophy, title: formatDate(customer.activeSince) }]
              : []),
          ]}
        />
      </div>
    </div>
  );
}
